<template>
    <div id="masterCenter">
        <my-header v-if="isSure"></my-header>
        <div class="bannerMaster">
            <img style="width:100%; min-width:1300px;" src="../../assets/images/masterCenter/topBg1.jpg"/>
            <div class="main-container">
                <div class="company">
                <span>
                    <img style="width:130px;height:130px;min-width:130px;" src="../../assets/images/masterCenter/avatar.png"/>
                </span>
                    <strong>{{ companyName}}</strong>
                </div>
            </div>
        </div>
        <section class="main-container main">
            <div class="needDeal">
                <el-tabs>
                    <el-tab-pane>
                        <span slot="label"> 我的待办</span>
                        <a class="more" href="javascript:;" @click="$router.push('/master/more/first')">查看更多&gt;&gt;</a>
                        <ul v-if="watingDealList.length" >
                            <li v-for="(item,index) in watingDealList" :key="index" :class="[ index == 5 ? 'lastLi' : '']">
                                <h4>
                                    <el-tooltip class="item" effect="dark" :content="item.dealTitle" placement="top">
                                        <strong @click="toProgress(item,1)">{{ item.dealTitle }}</strong>
                                    </el-tooltip>
                                    <el-button @click="toProgress(item,1)">查看详情</el-button>
                                </h4>
                                <p v-if="item.createDate">
                                   发起时间：<span>{{ item.createDate }}</span>
                                </p>
                            </li>
                        </ul>
                        <p v-else class="none">----暂无待办事项----</p>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label"> 我的已办</span>
                        <a class="more" href="javascript:;" @click="$router.push('/master/more/second')">查看更多&gt;&gt;</a>
                        <ul v-if="hadDealtList.length">
                            <li v-for="(item,index) in hadDealtList" :key="index" :class="[ index == 5 ? 'lastLi' : '']">
                                <h4>
                                    <el-tooltip class="item" effect="dark" :content="item.dealTitle" placement="top">
                                        <strong @click="toProgress(item,2)">{{ item.dealTitle }}</strong>
                                    </el-tooltip>
                                    <el-button @click="toProgress(item,2)">查看详情</el-button>
                                </h4>
                                <p v-if="item.dealDoneTime">
                                    处理时间：<span>{{ item.dealDoneTime }}</span>
                                </p>
                            </li>
                        </ul>
                        <p v-else class="none">----暂无已办事项----</p>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <div class="needDeal needDealRight">
                <el-tabs>
                    <el-tab-pane>
                        <span slot="label"> 我的消息</span>
                        <a class="more" href="javascript:;" @click="$router.push('/master/more/third')">查看更多&gt;&gt;</a>
                        <ul v-if="messageList.length" >
                            <li v-for="(item,index) in messageList" :key="index" :class="[ index == 5 ? 'lastLi' : '']" >
                                <h4>
                                    <el-tooltip class="item" effect="dark" :content="item.msgTitle" placement="top">
                                        <strong @click="showDialog(item,index)">{{ item.msgTitle }}</strong>
                                    </el-tooltip>
                                    <el-button @click="showDialog(item,index)">查看详情</el-button>
                                </h4>
                                <p v-if="item.createDate">
                                    发送时间：<span>{{ item.createDate}}</span>
                                </p>
                            </li>
                        </ul>
                        <p v-else class="none">----暂无未读消息----</p>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <!-- <div class="dealed">
                <h3>
                    我的消息
                </h3>
                <ul v-if="messageList.length">
                    <li v-for="(item,index) in messageList" :key="index" @click="showDialog(item,index)">
                        <h4 class="infoTitle" >
                            <el-tooltip class="item" effect="dark" :content="item.msgTitle" placement="top">
                                <strong>{{ item.msgTitle }}</strong>
                            </el-tooltip>
                        </h4>
                        <p v-if="item.createDate">
                            消息时间：<span>{{ item.createDate}}</span>
                        </p>
                    </li>
                </ul>
                <p v-else class="none">没有未读消息了~</p>
                <p>
                    <a class="more" href="javascript:;" @click="$router.push('/master/more/third')">查看更多&gt;&gt;</a>
                </p>
            </div> -->
        </section>
        <el-dialog
            class="messageDialog"
            title= '消息通知'
            :visible.sync="dialogVisible"
            @close="closeDialog"
            width="30%">
            <p>{{ dialogTitle }}</p>
            <p>{{ dialogContent ? '详情：'+ dialogContent : ''}}</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDialog">确 定</el-button>
             </span>
        </el-dialog>
        <el-dialog
            title= '请选择登录身份'
            :visible.sync="dialogUserVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="30%">
            <el-form :model="formData"
                     :rules="formRules"
                     ref="roleForm"
                     class="roleForm"
                     label-width="120px">
                <el-form-item label="登录身份：" prop="roleType" >
                    <el-select size="medium" v-model="formData.roleType" placeholder="请选择" @change="changeType">
                        <el-option
                            v-for="(item,i) in roleOptions"
                            :key="i"
                            :label="item.accountType == 1 ? item.tenderingAreaName + '子账号' : '主账号'"
                            :value="item.tenderingAreaId || '0'">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeUserDialog">确 定</el-button>
             </span>
        </el-dialog>
        <my-footer></my-footer>
    </div>
</template>
<script type="text/babel">
    import MyHeader from './MasterHeader.vue';
    import MyFooter from "../common/Footer";
    export default {
        name: 'master-center',
        data() {
            return {
                companyName: window.sessionStorage.getItem('companyName'),
                dialogVisible: false,//是否显示弹出层
                dialogTitle: '',
                dialogContent: '',
                watingDealList: [],//我的待办
                hadDealtList: [],//我的已办
                messageList:[],//我的消息列表
                currentId: '',//当前点击的第几个消息的id；
                currentJson: {},//当前账号选的第几个的json
                roleOptions: [],//当前账号的角色类型
                formData: {
                    roleType:'',//当前登录人类型，主管理员还是 地区公司
                },
                formRules: {
                    roleType: [
                        {required: true, message: '请选择登录身份'}
                    ]
                },
                dialogUserVisible: false,//登录人角色弹层
                accountType: 0,//0 主账号，1 子账号
                isSure: true,//是否开始加载头部
            }
        },
        components: {MyHeader,MyFooter},
        created(){
            this.$root.activeIndex = 'home';
            this.getData();
        },
        mounted(){
            if( window.sessionStorage.getItem('isShowLog')){//如果是从登录进入，显示弹层，否则，不显示
                this.getRoleOptions();
            } else {
                this.dialogUserVisible = false;
            }
        },
        methods:{
            getData(){
                var _this = this;
                this.$root.getHttp('/v1/outerformflow/managementCenter',function(res){
                    _this.watingDealList = res.data.data.watingDealList;
                    _this.hadDealtList = res.data.data.hadDealtList;
                    _this.messageList = res.data.data.messageList;
                })
            },
            getRoleOptions(){
                this.$root.postHttp('v1/pkuSupplierUserMessage/getArea',{
                    enterpriseName: window.sessionStorage.getItem('companyName'),
                    mobile: window.sessionStorage.getItem('loginAccount')
                }, res => {
                    this.roleOptions = res.data.data || [];
                    this.dialogUserVisible = false;
                })
            },
            changeType(val){//改变类型
                if(val === '0'){//主账号
                    this.accountType = 0;
                } else {//区域账号
                    this.accountType = 1;
                }
                this.roleOptions.forEach( item => {
                    if(item.tenderingAreaId && item.tenderingAreaId == val){
                        this.currentJson = item;
                    } else if(!item.tenderingAreaId && val === '0'){
                        this.currentJson = item;
                    }
                });
                window.sessionStorage.setItem('tenderingAreaId',val)
            },
            toProgress(val,entrance){
                if(val.actionType == 61){//邀请函待办
                    this.$router.push('/master/replyInvite/'+val.relatedId+'/'+entrance)
                } else if(val.actionType == 62){//资格预审待办
                    this.$router.push('/master/prequalification/'+val.relatedId+'/'+entrance)
                } else if(val.actionType == 63){//下载标书待办 id 是待办id;
                    this.$router.push('/master/downloadDoc/'+val.relatedId+'/'+entrance+'/'+(val.purchaseType || 0) + '/'+val.id)
                } else if(val.actionType == 65){//答疑补遗待办
                    this.$router.push('/master/processManagement/'+val.outerFormId+'/2');
                    //this.$router.push('/master/questions/'+val.relatedId+'/'+entrance+'/'+val.subRelatedId)
                } else if(val.actionType == 64 || val.actionType == 67 || val.actionType == 68){//回标待办 64，询标问卷 67，商务谈判 68 ，分标段
                    this.$router.push('/master/processManagement/'+val.id+'/2');
                } else if(val.dealSubType == 51){//信息核验退回待办,跳转到详情页;
                    this.$router.push('/master/basicInfo/'+entrance);
                }
            },
            showDialog(val,index){
//                var reg = new RegExp('"',"g");//去掉两边的双引号；
                var _this = this;
                this.dialogTitle = val.msgTitle;
                this.dialogContent = val.msgContent;
                this.dialogVisible = true;
                this.$root.getHttp('/v1/sMessages/readSMessage/'+ val.id,function(res){
                    _this.currentId = val.id;
                })
            },
            closeDialog(){//关闭消息通知弹层
                var _this = this;
                this.dialogVisible = false;
                this.messageList = this.messageList.filter( (item,i) => {
                    return item.id != _this.currentId;
                });
            },
            closeUserDialog(){//关闭用户登录弹层
                this.$refs.roleForm.validate( valid => {
                    if(valid){
                        this.isSure = false;
                        this.$root.postHttp('/v1/login/public/afterLogin',this.currentJson,res => {
                            res.data.data.suppliersSplitId && window.sessionStorage.setItem('suppliersSplitIdArr',res.data.data.suppliersSplitId);
                            if(this.accountType == 1){//1 区域账号，0 主账号
                                window.sessionStorage.setItem('isMaster',1);
                            } else {
                                window.sessionStorage.setItem('isMaster',0);
                            }
                            this.isSure = true;
                            window.sessionStorage.setItem('tenderingAreaId',this.currentJson.tenderingAreaId || '');//如果是区域账号，设置区域id，主账号，设置为‘’；
                            this.dialogUserVisible = false;
                            window.sessionStorage.setItem('isShowLog','');
                            this.getData();
                        },err => {
                            this.isSure = true;
                        });
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/var";
    #masterCenter {
        padding-top: 80px;
        background: #fff;
        & .head-top{
            background: #fff;
        }
        .bannerMaster {
           /* & img {
                !*width: 100%;*!
                height: 140px;
            }*/
            & .main-container {
                position: relative;
            }
            & .company {
                position: absolute;
                left: 0px;
                bottom: -70px;
                & span {
                    vertical-align: middle;
                    display: inline-block;
                    border: 5px solid #fff;
                    border-radius: 5px;
                   /* img {
                        width: 130px;
                        height: 130px;
                    }*/
                }
                & strong {
                    display: inline-block;
                    vertical-align: middle;
                    margin: 70px 0 0 20px;
                }
            }
        }
        .main {
            margin-top: 100px;
            overflow: hidden;
            padding-bottom: 30px;
            & .needDeal,
            & .dealed {
                float: left;
                padding: 50px 20px 20px;
                box-sizing: border-box;
                border: 1px solid $--secondary-fill-color;
                border-radius: 5px;
                background: #fff;
                & .more {
                    color: $--primary-color;
                   text-decoration: none;
                   font-size: 12px;
                   line-height: 30px;
                }
                .more:hover {
                    text-decoration: underline;
                }
                li strong:hover  {
                    cursor: pointer;
                    color: $--primary-color;
                    text-decoration: underline;
                }
            }
            & .needDealRight{
                    margin-left: 30px;
                }
            & .needDeal {
                min-height: 570px;
                width: 595px;
                & h3 {
                    overflow: hidden;
                    & img {
                        float: left;
                        width: 224px;
                        height: 30px;
                    }
                    & a {
                        float: right;
                    }
                }
                & ul {
                    margin-top: 15px;
                    & li {
                        padding: 15px 0;
                        border-bottom: 1px solid $--secondary-fill-color;
                        & h4 {
                            overflow: hidden;
                            & strong {
                                float: left;
                                max-width: 420px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                font-size: 14px;
                                line-height: 32px;
                            }
                            & .el-button {
                                float: right;
                                padding: 8px 12px;
                            }
                        }
                        & p {
                            padding-left: 28px;
                            text-align: left;
                            font-size: 12px;
                            line-height: 24px;
                            color: $--text-color-lighter;
                            background: url('../../assets/images/masterCenter/icon01.png') no-repeat;
                        }
                    }
                    & .lastLi {
                        border: none;
                    }
                }
                .el-tabs {
                    position: relative;
                    .el-tabs__content {
                        position: static;
                    }
                    .el-tabs__item {
                        font-size: 16px;
                        width: 120px;
                        height: 32px;
                        padding: 0;
                        line-height: 30px;
                    }
                    .el-tabs__item.is-active {
                        border: 1px solid #cb1235;
                        color: #cb1235;
                        border-radius: 3px;
                        font-weight: 700;
                    }
                    .el-tabs__nav-wrap:after {
                        background-color: #fff;
                    }
                    .el-tabs__active-bar {
                       display:none;
                    }
                }
                .more {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    z-index: 3;
                }
            }
            & .dealed {
                padding-bottom: 50px;
                width: 400px;
                margin-left: 20px;
                & h3 {
                    font-size: 18px;
                }
                & h3::before,
                & h3::after {
                    vertical-align: middle;
                    display: inline-block;
                    content: '';
                    width: 10px;
                    height: 10px;
                    background: url('../../assets/images/masterCenter/titBg.png') no-repeat;
                }
                & ul {
                    margin-top: 25px;
                    max-height: 340px;
                    overflow: hidden;
                }
                & ul li {
                    cursor: pointer;
                    text-align: left;
                    margin: 30px 0;
                    font-weight: bold;
                    .infoTitle {
                        padding: 0 44px 0 24px;
                        /*padding-left: 24px;*/
                        background: url('../../assets/images/masterCenter/icon02.png') no-repeat;
                        font-weight: inherit;
                        height: 24px;
                        font-size: 14px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        strong {
                            font-weight: inherit;
                            display: inline-block;
                            vertical-align: top;
                            width: 150px;
                        }
                    }
                    .infoTitle:hover strong {
                        color: $--primary-color;
                    }
                    p {
                        padding-left: 24px;
                        font-size: 12px;
                        line-height: 24px;
                        color: $--text-color-lighter;
                    }
                }
            }
        }
        .messageDialog {
            .el-dialog__headerbtn .el-dialog__close {
                padding: 3px;
                border: 1px solid #999;
                border-radius: 50%;
                transform: rotate(0deg);
                transition: .5s transform;
            }
            .el-dialog__headerbtn .el-dialog__close:hover {
                transform: rotate(180deg);
                border-color: #cb1235;
            }
            .el-dialog__title {
                font-size: 16px;
                font-weight: 700;
            }
            .el-dialog__body {
                padding-top: 20px;
            }
            p {
                text-align: left;
                text-indent: 2em;
            }
            p:nth-of-type(1){
                font-weight: bold;
                line-height: 34px;
            }
        }
        .roleForm {
            .el-form-item__content {
                text-align: left;
            }
        }
        .none {
            margin: 55px 0 70px;
            font-size: 16px;
            line-height: 40px;
            color: $--text-color-lighter;
            border: 1px solid $--text-color-lighter;
            border-radius: 3px;
        }
        .needDeal .none {
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/MasterCenter.vue